import IconHOC from '../IconHOC';

import { ReactComponent as MailIcon } from './mail.svg';

export const Mail = IconHOC(MailIcon);
